export default "<input\n  type=\"text\"\n  [(ngModel)]=\"comment\"\n  class=\"form-control padding-0\"\n  placeholder=\"\"\n/>\n"